import { State } from './type'

const state: State = {
    setMenuState: false,
    detail: null
}

const mutations = {
    toggleMenuSetMenuState(state: { setMenuState: boolean }, value: boolean) {
        state.setMenuState = value
    },
    setMenuDetail(state: { detail: null | Object }, value: Object | null) {
        state.detail = value
    }
}
export default {
    state,
    mutations
}
